@if (showDefaultNav) {
  <div class="border-ace-grey-400 border-b">
    <header class="font-body container bg-white relative !p-0 {{ activateMobileMenu ? '!fixed inset-0 !max-w-full w-full z-50 flex flex-col overflow-hidden' : '' }}">
      <skip-nav></skip-nav>
      <div [class.border-b]="activateMobileMenu">
        <div class="header-wrapper flex-wrap flex align-top !px-6"
          [class.!py-0]="activateMobileMenu"
          >
          <!-- Aceable logo -->
          <a href="/" class="mr-auto lg:mr-6 py-5" aria-label="Mortgage Navigation Link">
            <img
              class="ace__nav-logo max-h-10"
              src="{{ headerLogo }}"
              width="175"
              height="38px"
              alt="Aceable Mortgage Logo (Header)"
              />
          </a>
          <!-- Default Nav -->
          <nav class="ace__nav hidden lg:flex flex-grow align-middle">
            @for (navLink of headerData; track navLink) {
              <ace-header-navlink [data]="navLink" class="flex items-center first:ml-0 mx-3">
              </ace-header-navlink>
            }
          </nav>
          <!-- My Account Dropdown -->
          <nav class="ace__nav hidden lg:flex align-middle">
            @for (navLink of myAccountData; track navLink) {
              <ace-header-navlink [data]="navLink"
                class="relative flex items-center my-account">
              </ace-header-navlink>
            }
          </nav>
          <!-- Mobile Hamburger -->
          <button
            (click)="toggleMobileMenu()"
      class="
        text-ace-teal-800
        focus:outline-none
        font-body
        flex
        lg:hidden
        items-center
        self-center
      "
            >
            <img
              [attr.loading]="'eager'"
              width="32px"
              height="32px"
              class="w-8 h-8"
              [src]="activateMobileMenu ? 'https://xgrit-ecom.imgix.net/ace/X.svg?v=1712674314' : 'https://xgrit-ecom.imgix.net/ace/Hamburger-Menu.svg?v=1712674404'"
              [alt]="activateMobileMenu ? 'Close navigation menu' : 'Open navigation menu'"
              />
          </button>
        </div>
      </div>
      <!-- Mobile Nav Menu -->
      @if (activateMobileMenu) {
        <div
          class="ace__nav-mobile bg-white flex flex-col justify-items-start content-start lg:hidden relative flex-1 min-h-0 overflow-hidden"
          >
          <div class="flex-1 min-h-0 overflow-y-auto overscroll-contain">
            <div class="bg-white">
              @for (link of headerData; track link) {
                <collapse-link [link]="link"></collapse-link>
              }
              @for (link of myAccountData; track link) {
                <collapse-link [link]="link"></collapse-link>
              }
            </div>
            <div class="p-v-spacing">
              <a
                href="https://app.aceable.com/user/signin"
          class="
            ace__nav-sign-up
            secondary-button
            sm:w-fit
          "
                >
                Sign In
              </a>
            </div>
          </div>
        </div>
      }
    </header>
  </div>
}

